"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListViewIcon = void 0;
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const ListViewIcon = (_a) => {
    var { stroke = 'currentColor', fill = 'transparent' } = _a, props = __rest(_a, ["stroke", "fill"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("rect", { x: "3", y: "4", width: "18", height: "4", rx: "1.5", fill: fill, stroke: stroke, strokeWidth: "1.5" }), react_1.default.createElement("rect", { x: "3", y: "10", width: "18", height: "4", rx: "1.5", fill: fill, stroke: stroke, strokeWidth: "1.5" }), react_1.default.createElement("rect", { x: "3", y: "16", width: "18", height: "4", rx: "1.5", fill: fill, stroke: stroke, strokeWidth: "1.5" })));
};
exports.ListViewIcon = ListViewIcon;
exports.default = exports.ListViewIcon;
